var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#757983",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "m14.916 14.918 3.834 3.833"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#757983",
  strokeMiterlimit: 10,
  d: "M10.913 16.576a5.662 5.662 0 1 0 0-11.325 5.662 5.662 0 0 0 0 11.325Z"
})));
export default SvgSearch;